<template>
  <div class="warper clearfix categoriesBox">
    <div class="h1box">
      <h1>User Guide</h1>
    </div>
    <div class="jisuBox-header pointer" >
      <!-- <span style="margin-right:0.5rem" >Auto Config Network</span> -->
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.246094 6.25C0.246094 5.69771 0.693809 5.25 1.24609 5.25H7.83188L5.03899 2.45711C4.64846 2.06658 4.64846 1.43342 5.03899 1.04289C5.42951 0.652369 6.06268 0.652369 6.4532 1.04289L10.9525 5.54218C10.9554 5.54511 10.9583 5.54805 10.9612 5.55101C11.0531 5.64499 11.1228 5.75259 11.1702 5.86722C11.2186 5.98378 11.2455 6.11147 11.2461 6.24538L11.2461 6.25L11.2461 6.25422C11.2449 6.52687 11.1345 6.77415 10.9565 6.95383L10.9527 6.95761L6.4532 11.4571C6.06268 11.8476 5.42951 11.8476 5.03899 11.4571C4.64846 11.0666 4.64846 10.4334 5.03899 10.0429L7.83188 7.25H1.24609C1.21158 7.25 1.17747 7.24825 1.14385 7.24484C0.639593 7.19363 0.246094 6.76777 0.246094 6.25Z"
          fill="white"
        /> -->
      </svg>
    </div>
    <div class="jisuBox">
      <a-row type="flex" justify="space-around" align="top">
        <a-col
          :span="6"
          v-for="(item, index) in JiSu_List"
          :key="'JiSu' + item.id"
          class="cate-box"
        >
          <div class="cate-name1" style="position:relative">
            <i v-if="index == 0" class="iconfont icon-menu-overview" ></i>
            <i v-if="index == 1" class="iconfont icon-menu-project" ></i>
            <i v-if="index == 2" class="iconfont icon-other-tuning" ></i>
            <i v-if="index == 3" class="iconfont icon-prof-projects" ></i>
            <span>{{ item.name }}</span>
          </div>
          <div class="cate-info1">
            <ul v-if="index != 1">
              <li
              :key="child.id"
                v-for="child in item.children"
                style="list-style-type: disc; "
                @click="goUrl(child)"
              >
                <span
                  class="disable CatePointer"
                  v-if="child.flag == 'disable'"
                >
                  {{ child.name }}
                </span>
                <span class="CatePointer PointerHover" v-else>
                  {{ child.name }}
                </span>
              </li>
            </ul>
            <ul v-else>
              <a-row type="flex">
                <a-col
                  ><li
                    v-for="(child, childIndex) in getFirstColumnChildren(item.children)"
                    :key="childIndex"
                    style="list-style-type: disc;"
                    @click="goUrl(child)"
                  >
                    <span
                      class="disable CatePointer"
                      v-if="child.flag == 'disable'"
                    >
                      {{ child.name }}
                    </span>
                    <span v-else class="CatePointer PointerHover">
                      {{ child.name }}
                    </span>
                  </li></a-col
                >
                <a-col
                  ><li
                    v-for="(child, childIndex) in getSecondColumnChildren(item.children)"
                    :key="childIndex"
                    style="list-style-type: disc; "
                    @click="goUrl(child)"
                  >
                    <span
                      class="disable CatePointer"
                      v-if="child.flag == 'disable'"
                    >
                      {{ child.name }}
                    </span>
                    <span v-else class="CatePointer PointerHover">
                      {{ child.name }}
                    </span>
                  </li></a-col
                >
              </a-row>
            </ul>
          </div>
          <div v-if="index != 3" class="cate-arrow">
            <img src="../assets/icon/cate/cate-arrow.png" />
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="otherBox">
      <a-row type="flex"  align="top">
    
        <div
          v-for="(first, index) in List"
          :key="'first' + index"
          style="width:20%;     padding-left: 40px;"
        >
          <div class="cate-name2">{{ first.name }}</div>
          <div
            v-for="(second, index) in first.children"
            :key="'second' + index"
            @click="goUrl(second)"
          >
            <p class="disable CatePointer" v-if="second.flag == 'disable'">
              {{ second.name }}
            </p>
            <p class="CatePointer PointerHover" v-else>
              {{ second.name }}
              <!-- <i v-if="second.flag == 'HOT' || second.flag == 'hot'" class="iconfont icon-hot" color="#DE321F"></i> -->
            </p>
          </div>
        </div>
         <div
          v-for="(first, index) in List2"
          :key="'first' + index"
          style="width:20%;     padding-left: 40px;"
        >
          <div class="cate-name2" style="margin-top:40px">{{ first.name }}</div>
          <div
            v-for="(second, index) in first.children"
            :key="'second' + index"
            @click="goUrl(second)"
          >
            <p class="disable CatePointer" v-if="second.flag == 'disable'">
              {{ second.name }}
            </p>
            <p class="CatePointer PointerHover" v-else>
              {{ second.name }}
              <!-- <i v-if="second.flag == 'HOT' || second.flag == 'hot'" class="iconfont icon-hot" color="#DE321F"></i> -->
            </p>
          </div>
        </div>
      
      </a-row>
    </div>
  </div>
</template>
<script>
import { categories } from "@/utils/query.js";

export default {
  data() {
    return {
      JiSu_List: [],
      List: [],
      List2: [],
    };
  },
  computed: {
    // Filter children for first column (index <= 5)
    getFirstColumnChildren() {
      return (children) => children.filter((_, index) => index <= 5);
    },
    // Filter children for second column (index > 5)
    getSecondColumnChildren() {
      return (children) => children.filter((_, index) => index > 5);
    },
  },
  created() {
    this.getCate();
  },
  methods: {
    async getCate() {
      let res = await categories();
      this.List = [];
      this.List2 = [];
      if (res.code == '200') {
        this.JiSu_List = res.data.directoryJson[0].children;
        this.List = res.data.directoryJson.filter((element, index, self) => {
          return index > 0 && index <= 5;
        });
        this.List2 = res.data.directoryJson.filter((element, index, self) => {
          return index > 5 ;
        });
      }

    },
    goJiSu() {
      this.$router.push({
        name: "JiSu",
      });
      this.sentzhugePoint("极速智能配置说明页面");
    },
    // bz位代表是否是极速智能配置
    goUrl(item) {
      let id = item.id;
      if (item.children.length >= 1) {
        id = item.children[0].id;
      }
      this.$router.push({
        name: "ArticleList",
        query: { id },
      });
    },
    sentzhugePoint(lv01 = "") {
      this.zhugePoint("macc-help-文档中心-模块统计", {
        userid: this.GLOBAL.userid, //用户id
        lv01, //一级目录、模块
      });
    },
  },
};
</script>
<style scoped>
.categoriesBox {
  min-height: 42vh;
}
.h1box {
  text-align: center;
  padding: 2rem;
  padding-bottom: 1.5rem;
}
.h1box h1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  padding-bottom: 8px;
  position: relative;
  display: inline-block;
}
.h1box h1::after {
  content: "";
  background: var(--theme-color);
  border-radius: 9px;
  height: 0.5rem;
  width: 5rem;
  position: absolute;
  top: 100%;
      left: 50%;
    transform: translateX(-50%);
}

.jisuBox-header {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  /* height: 6rem; */
  height: 96px;
  width: 293px;
  text-align: center;
  background: url("../assets/icon/js_bg.png") center no-repeat;
  border-radius: 0.5rem 2rem 0.5rem 0.5rem;
  backdrop-filter: blur(20px);
  padding-top: 12px;
}
.jisuBox-header span {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: var(--text-white-title);
}
.jisuBox {
  margin-top: 50px;
  background: var(--white-80);
  border: 1px solid var(--theme-light);
  box-shadow: 2px 6px 15px var(--gray-80);
  backdrop-filter: blur(40px);
  padding: 25px 0;
  min-height: 330px;
  height: auto;
}
.cate-box {
  /* border: var(--theme-color) 1px solid; */
  position: relative;
  padding: 0 24px;
  min-height: 230px;
  height: auto;
}
.cate-name1 {
  margin-bottom: 10px;
}
.cate-name1 span {
  display: inline-block;
  color: var(--text-title);
  font-weight: 600;
  font-size: 18px;
  vertical-align: middle;
  line-height: 26px;
}
.cate-name1 .iconfont {
  vertical-align: middle;
  margin-right: 0.7rem;
  color: var(--theme-color);
  font-size: 26px;
  line-height: 26px;
}

.cate-info1 {
  font-size: 14px;
  line-height: 28px;
  color: var(--text-secondary);
  padding-left: 1em;
}

.cate-arrow {
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 0rem;
}
.otherBox {
  padding-top: 3rem;
  padding-bottom: 5rem;
}
.cate-name2 {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-title);
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--theme-light);
}
.cate-info2 {
  font-size: 14px;
  line-height: 22px;
  color: var(--text-secondary);
}
.CatePointer {
  cursor: pointer;
}
.PointerHover:hover {
  color: var(--theme-color);
}
.disable {
  color: var(--text-placeholder);
}
.otherBox-test {
  display: flex;
  flex-direction: column;
}
</style>
